import React from 'react';
import {Button, Icon} from 'semantic-ui-react';
import {FormattedMessage} from "react-intl";
import {Form, Grid, Label, Loader} from "semantic-ui-react";
import catchErrors from 'hoc/catchErrors';

/*

*/
class CurrentId extends React.Component {

    constructor(props) {
        super(props);

        // console.log('CurrentId', props)

        this.state = {
            data: props.value
        };

        // console.log('x', props.formProxy.resource['DAILYBREAK'])
        // console.log('props.name', props.name)
        try {
            let resource = props.formProxy.resource['DAILYBREAK']
            // when we look at resouce the resource id from teh break (pid, pqid) have been translated to 'id'
            this.id = resource ? resource.id : null 

        } catch(e) {
            console.log(e)
        }

    }

    render() {

        return (

            <div>

                <Grid columns="equal">
                    <Grid.Row className="db-field-label-row">
                        {this.props.field.label}: { this.id }
                    </Grid.Row>

                    {/*
                    <Grid.Row className='db-field-label-row'>
                        <Label basic className='db-field-label'>
                            {this.props.required && <i className='icon asterisk inline required' />}
                            {this.props.label}<Loader active={this.props.loading} inline /> {this.props.loading}
                        </Label>
                    </Grid.Row>
                    */}

                {/*
                    { (this.stringToArray(this.state.data).length > 0) &&
                    <Grid.Row className="db-field-label-row">
                        <Label basic className="db-field-label">Key</Label>
                        &nbsp;
                        <Label basic className="db-field-label">Value</Label>
                    </Grid.Row>

                    }
                    */}
                </Grid>



            </div>
        )
    }
};

export default catchErrors(CurrentId);


// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/CurrentId.jsx